import { Checkbox, FormControlLabel, FormGroup, Stack } from "@mui/material";
import { Controller, SubmitHandler, useForm } from "react-hook-form";

import StyledLoadingButton from "../../../../common/providers/theme/design-tokens/LoadingButton/StyledLoadingButton";
import {
  MITIGATED_RISKS,
  MITIGATED_RISKS_ENUM,
} from "../../../data-hub/components/models/common/events.constants";

interface IFeedbackForm {
  risks: Record<string, boolean>;
}

interface IFeedbackDetailsFormProps {
  mitigatedRisk?: string[];
  submitLoading?: boolean;
  onCancel: () => void;
  onSubmitClick: (mitigatedRisk: string[]) => Promise<void>;
}

const FeedbackDetailsForm = ({
  mitigatedRisk,
  onCancel,
  onSubmitClick,
  submitLoading,
}: IFeedbackDetailsFormProps) => {
  const filteredMitigatedRisks = MITIGATED_RISKS.filter(
    risk => risk !== MITIGATED_RISKS_ENUM.LOSS_OF_CONTAIMENT_PERCENT
  );

  const { handleSubmit, control } = useForm<IFeedbackForm>({
    defaultValues: {
      risks: filteredMitigatedRisks.reduce((acc, risk) => {
        const mitigatedRiskFound = mitigatedRisk?.includes(risk);

        acc[risk] = Boolean(mitigatedRiskFound);

        return acc;
      }, {} as Record<string, boolean>),
    },
    mode: "onChange",
  });

  const onSubmit: SubmitHandler<IFeedbackForm> = async data => {
    const selectedItems = Object.keys(data.risks).filter(
      key => data.risks[key]
    );

    await onSubmitClick(selectedItems);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <FormGroup>
        {filteredMitigatedRisks.map(risk => (
          <Controller
            key={risk}
            name={`risks.${risk}`}
            control={control}
            render={({ field }) => (
              <FormControlLabel
                control={<Checkbox {...field} checked={field.value} />}
                label={risk}
              />
            )}
          />
        ))}
      </FormGroup>
      <Stack
        display="flex"
        flexDirection="row"
        justifyContent="center"
        gap={2}
        sx={{ paddingTop: 3 }}
      >
        <StyledLoadingButton
          startIcon={null}
          loadingPosition="start"
          variant="outlined"
          color="inherit"
          onClick={onCancel}
        >
          Cancel
        </StyledLoadingButton>
        <StyledLoadingButton
          type="submit"
          loading={submitLoading}
          startIcon={null}
          loadingPosition="start"
          variant="contained"
          color="primary"
        >
          Apply
        </StyledLoadingButton>
      </Stack>
    </form>
  );
};

export default FeedbackDetailsForm;
